<script>
export default {
    name: 'CpSocialFeedStartCampaignPost',
    components: {
        CpButton: require('../../button').default,
    },
    directives: {
        margin: require('../../directives/margins').margin,
        marginBottom: require('../../directives/margins').marginBottom,
        marginRight: require('../../directives/margins').marginRight,
    },
    methods: {
        redirectTo(path) {
            window.location.href = path;
        },
    }
};
</script>

<template>
    <div class="container">
        <h3 class="subheadline1 primary-color text-center text">Thinking About Running for Office?</h3>
        <img src="/assets/img/vote-img.png" alt="Vote image" width="46" height="46" />
        <p class="footnote neutral4-color text-center text">Raise money for your candidancy, another candidate, or for a cause.</p>
        <cp-button primary block @click="redirectTo('/campaigns/learn')">Sign Up</cp-button>
        <cp-button noborder block @click="redirectTo('/campaigns/learn')">Learn more...</cp-button>
    </div>
</template>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    border: 1px solid var(--primary-blue-500);
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px #00000033;
    background-color: var(--white);
}

.text {
    padding: 0 16px;
}

@media screen and (max-width: 768px) {
    .container {
        max-width: 250px;
    }
}
</style>